import { render, staticRenderFns } from "./AdminData.vue?vue&type=template&id=79380a08&scoped=true&"
import script from "./AdminData.vue?vue&type=script&lang=js&"
export * from "./AdminData.vue?vue&type=script&lang=js&"
import style0 from "./AdminData.vue?vue&type=style&index=0&id=79380a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79380a08",
  null
  
)

export default component.exports